/**
 * Hero sections with section.index > 1 use preload="none" (see hero.liquid).
 * Hydrates muted autoplay loop videos when they near the viewport.
 */
(function () {
  const videos = document.querySelectorAll('video.hero__media[preload="none"]');
  if (!videos.length) return;

  const hydrate = (video) => {
    if (video.dataset.topshelfLazyHydrated) return;
    video.dataset.topshelfLazyHydrated = 'true';
    video.preload = 'auto';
    video.load();
    const p = video.play?.();
    if (p && typeof p.catch === 'function') p.catch(() => {});
  };

  if (!('IntersectionObserver' in window)) {
    videos.forEach(hydrate);
    return;
  }

  const io = new IntersectionObserver(
    (entries, observer) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        observer.unobserve(entry.target);
        hydrate(entry.target);
      }
    },
    { rootMargin: '280px 0px', threshold: 0.01 }
  );

  videos.forEach((v) => io.observe(v));
})();
